<!-- 模板文书设置 -->
<template>
  <div>
    <Table
      ref="table"
      :dict="[]"
      :option="{}"
      :colObj="{
        opId: 3694,
        col: [],
        dataClass:2,
      }"
      :filterObj="{MBWSID:$route.query.ID}"
    >
    </Table>
    <el-dialog
        :visible.sync="dialog"
        :append-to-body="true"
        width="60%"
        top="5vh"
        title="新增"
        @closed="dialogclose"
        :close-on-click-modal="false"
        :show-close="false"
        v-dialogdrag
    >
        <table border="1" style="width:100%">
            <tr>
                <td>模板名称：</td>
                <td style="wdith:30%">
                    <el-input size='mini' v-model="form.MBMC"></el-input>
                </td>
                <td>模板主属性名称：</td>
                <td style="wdith:30%">
                    <el-input size='mini' v-model="form.MBZSXMC"></el-input>
                </td>
            </tr>
            <tr>
                <td>制定级别：</td>
                <td>
                  <el-select style="width:100%" size='mini' v-model="form.CRT_LEVEL" placeholder="请选择">
                    <el-option
                      v-for="item in ZDJB"
                      :key="item.ID"
                      :label="item.dictValue"
                      :value="item.dictKey">
                    </el-option>
                  </el-select>
                    <!-- CRT_LEVEL -->
                </td>
                <td>制定单位：</td>
                <td>
                  <selectpage
                      class="selectpage-item"
                      v-model="form.CRT_COMPANYID"
                      :selectData="{
                        selectData: [
                          { prop: 'COMPANY_NAME', label: '单位名称', width: 294 },
                          { prop: 'COMPANY_CODE', label: '单位编码', width: 136 },
                          { prop: 'ORG_LEVEL', label: '机构级别',width:92}
                        ]
                      }"
                      height="27px"
                      placeholder="请选择承办人"
                      searchslotid="112"
                      keyfield="ID"
                      showField="COMPANY_NAME"
                      label="单位名称"
                      @corField="corFieldFn1"
                    >
                    </selectpage>
                    <!-- CRT_COMPANYID -->
                </td>
            </tr>
        </table>
        <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="saveClick" :loading='loading'>保存</el-button>
        <el-button size="mini" @click="dialog = false" :loading='loading'>关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Table from '@/components/table/dataTablec';
import { getDictionary } from "@/api/system/dict";
import {addShow} from "@/api/table/table";
import Selectpage from "@/components/table/template/Selectpage";
import {mapGetters} from "vuex";
export default {
  components: {
    Table,
    Selectpage
  },
  data() {
    return {
      firstEnter: true,
      dialog:false,
      form:{},
      ZDJB:[],
      loading:false
    };
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    addClick(btn,row){
      this.dialog = true
      this.form = {
        CRT_LEVEL:this.userInfo.user_level,
        CRT_COMPANYID:this.userInfo.company_id
      }
    },
    async getDic(){
        let [SYS_MANAGE_LEVEL] = await Promise.all([
        getDictionary({ code: "SYS_MANAGE_LEVEL" })
      ])
      this.ZDJB = SYS_MANAGE_LEVEL.data.data
      console.log(SYS_MANAGE_LEVEL.data.data)
    },
    saveClick(){
      this.loading = true
      addShow({
        opid:3694,
        dataClass:2,
        data:{...this.form,MBWSID:this.$route.query.ID},
        runId:this.$route.query.runId
      }).then((res) => {
        this.loading = false
        this.$refs.table.$refs.child.onLoad();
        this.dialog = false
      }, err => {
      });
    }
  },
  activated() {
    this.getDic()
    // if (this.firstEnter) {
    //   this.firstEnter = false;
    // } else {
    //   this.$refs.table.$refs.child.onLoad();
    // }
  }
};
</script>

<style lang="scss" scoped>
  table{
    border-color: #87b8e6;
    td:nth-child(2n-1){
      background-color: rgb(241,250,255);
      text-align: right;
      width: 20%;
    }
  }
</style>
